import { BooleanFilterEnum } from '../../../shared/enums/boolean-filter.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { AssetFeatureItemTypeEnum } from '../enums/asset-feature-item-type.enum';

/**
 * Asset feature items filters
 */
export class AssetFeatureItemsFilters extends ApiRequestFilters {
	/**
	 * Types
	 */
	types?: AssetFeatureItemTypeEnum[];

	/**
	 * Hidden value
	 */
	hidden?: BooleanFilterEnum;
}
